module.exports = __webpack_public_path__ + "media/images/footer-d13d3033cfc2135e4a460a63cad46a5c.png";